import React from 'react';
import { OffthreadVideo } from 'remotion';
import { LayerWrapper } from './LayerWrapper';
import type { AnchorLayer as AnchorLayerConfig, UploadedAsset } from '../../types';

interface AnchorLayerProps {
  layer: AnchorLayerConfig;
  asset?: UploadedAsset;
}

export function AnchorLayer({ layer, asset }: AnchorLayerProps) {
  if (!asset) return null;

  return (
    <LayerWrapper
      position={layer.position}
      animation={layer.animation}
      opacity={layer.opacity}
      border={layer.border}
      borderRadius={layer.borderRadius}
      shadow={layer.shadow}
    >
      <OffthreadVideo
        src={asset.url}
        style={{ width: '100%', height: '100%', objectFit: layer.objectFit ?? 'cover' }}
        muted={layer.muted ?? false}
        // Chroma key requires post-processing — flagged for future FFmpeg integration
      />
    </LayerWrapper>
  );
}
